export default __webpack_public_path__ + "static/media/ivan.a7234c7d.jpg";